const itemsSearchPath = '/items/search';

export default itemsSearchPath;
